<script>
	import Module from '../components/Module.vue'

	export default {
		data: function(){
			return {
				name: 'YesOrNoContainer'
			}
		},
    components:{
			Module
    }
	}
</script>

<template>
	<Module topColor="#EC5A4B" bottomColor="#16A085">
		<span slot="title" class="section_name">YES OR NO?</span>
		<span slot="description" class="section_text">Should my wife wash the dishes today? Am I stupid? Let destiny decide!<br>Click the below button to find out!</span>
		<div slot="action">
			<span>ANSWER ME</span>
		</div>
	</Module>
</template>